// extracted by mini-css-extract-plugin
module.exports = {"singlePost":"styles_singlePost__3wp-0"};